import ahoy from "ahoy.js";

// Ahoy's JS beacon, running alongside its normal server-side tracking.
//
// /learn and /blog are cached at Cloudflare, and a response carrying
// Set-Cookie is one a shared cache refuses to store — so those controllers
// skip `track_ahoy_visit` and suppress the session cookie, and until now no
// visit was recorded for them at all. That cost more than a pageview count:
// `ahoy.visitor_token` is the join key behind field_test participation,
// policy_acceptances, dispute-evidence IP lookups and utm→chip attribution, so
// anyone landing on an article from an ad arrived at /register unattributed.
//
// The POSTs below are never cached (Cloudflare does not cache POST), and the
// cookies are written from JS rather than Set-Cookie, so the HTML stays
// cacheable exactly as it is today. Uncached pages still track server-side;
// both paths read and write the same ahoy_visitor cookie, so a visitor keeps
// one token from article to registration.

// Rails writes the ahoy cookies with `domain: :all` (config/initializers/
// ahoy.rb), which resolves to the registrable domain — "mchip.org" for any
// mchip.org host. ahoy.js would otherwise scope its cookies to the exact
// hostname, leaving the browser holding two `ahoy_visitor` cookies and the
// server reading whichever it was handed first. That fails quietly, as split
// attribution rather than an error, so keep this in step with
// `Ahoy.cookie_domain` — ahoy_beacon_test.rb pins the server half.
//
// Mirrors ActionDispatch::Cookies' handling of `:all`, down to emitting no
// leading dot: no domain at all for an IP or a single-label host, which is
// what keeps localhost and 127.0.0.1 working in development.
function cookieDomain(): string | null {
  const host = window.location.hostname;
  const labels = host.split(".");

  if (/^[\d.]+$/.test(host) || labels.length < 2) return null;

  return labels.slice(-2).join(".");
}

ahoy.configure({
  visitsUrl: "/pulse/visits",
  eventsUrl: "/pulse/events",
  cookieDomain: cookieDomain(),
});

// ahoy.js only POSTs a visit when the 4-hour visit cookie has lapsed, so on its
// own it records the landing page and nothing after it. trackView adds a $view
// event per page, which is what gives per-article traffic.
//
// This runs before ahoy's own start-up: the library schedules that through
// setTimeout on document-ready, and this module body is synchronous.
ahoy.trackView();

export default ahoy;
